import { Badge, BadgeProps } from '@payaca/ambrosia';
import { Nullish } from '@payaca/utilities/types';
import { FC } from 'react';

import { prettifyCommissioningStatus } from './commissioningStatusCopy';

type EnaCommissioningStatusBadgeProps = Omit<
  BadgeProps,
  'colour' | 'variant'
> & {
  commissioningStatus: Nullish<string>;
};

const EnaCommissioningStatusBadge: FC<EnaCommissioningStatusBadgeProps> = ({
  commissioningStatus,
  ...badgeProps
}) => {
  return (
    <Badge
      variant="soft"
      {...badgeProps}
      colour={getCommissioningStatusBadgeColor(commissioningStatus)}
    >
      {prettifyCommissioningStatus(commissioningStatus)}
    </Badge>
  );
};

function getCommissioningStatusBadgeColor(
  commissioningStatus: Nullish<string>
): 'green' | 'yellow' | 'red' | 'gray' {
  if (!commissioningStatus) {
    return 'yellow';
  }
  const lowerStatus = commissioningStatus?.toLowerCase();

  if (lowerStatus.includes('accepted')) {
    return 'green';
  } else if (lowerStatus.includes('update required')) {
    return 'red';
  } else if (lowerStatus.includes('ex mpan provided')) {
    return 'green';
  } else {
    return 'gray';
  }
}

export default EnaCommissioningStatusBadge;
